<template>
    <el-dialog
        append-to-body
        class="send-now-modal"
        :visible.sync="showLocal"
        :close-on-click-modal="false"
        width="900px">
        <div slot="title">
            Selection to be Pushed to EMR
        </div>
        <div class="event-head">
            <span>
                EVENT
            </span>
            &#8211;
            <span>
                {{ emrData.title }}
            </span>
            &middot;
            <span>
                {{ emrData.displayTime }}
            </span>
        </div>
        <div class="notes">
            <TextEdit 
                class="text-edit"
                v-model="copNote"
                :textEditId="parCopNoteId"
            ></TextEdit>
        </div>
        <div slot="footer" class="footer">
            <div class="inl-blk">
                <span class="ask-text">Are you sure you want to push notes to <b>{{emrData.emrTitle}}</b>?</span>
            </div>
            <div class="inl-blk">
                <el-button @click="showLocal = false"  size="large">Cancel</el-button>
                <LoadingButton
                    type="primary"
                    :loading="loading"
                    :disabled="loading"
                    :loaded="loaded"
                    @click="saveNoteQuestionnaire">
                    Confirm
                </LoadingButton>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import LoadingButton from '@/module/component/LoadingButton'
import TextEdit from '@/module/component/TextEdit'

export default {
    name: 'par-cop-note-dialog',
    props: ["copNote","emrData", "dialogShow", "patient", "parCopNoteId"],

    data() {
        return {
            loading: false,
            disabled: false,
            loaded: false,
            showLocal: this.dialogShow
        }
    },

    watch: {
        showLocal(newValue) {
            if(newValue === false)
                this.$emit('close-confirmation')
        }
    },

    methods : {
        ...mapActions('provider', ['pushNoteCategory']),
        saveNoteQuestionnaire() {
            if(this.parCopNoteId === this.emrData.id) {
                const emrData = this.emrData
                const queryData = {
                    schedule: emrData.schedule,
                    emr_category: emrData.emrId,
                    id: this.patient.id,
                    provider: emrData.provider
                }
                if(emrData.pushType === 'questionnaire') {
                    queryData.questionnaire_notes = {
                        [emrData.id] : this.copNote.replace(/<\/?[Bb][Rr]>\s?/g, '\n').replace( /(<([^>]+)>)/ig, '')
                    }
                }
                this.loading = true
                this.pushNoteCategory(queryData)
                    .then((response) => {
                        this.showLocal = false
                        this.$message({
                            message: response.success ? ('Pushed to ' + emrData.emrTitle) : ('Failed to push to ' + emrData.emrTitle),
                            type: response.success ? 'success' : 'error'
                        })
                    }).catch((error) => {
                        if(!error.success)
                            this.$message.error(error.description)
                    }).finally((_) => this.loading = false)
            }
        }
    },

    computed: {
        ...mapGetters('content', ['getContentKey'])
    },

    components: {
        LoadingButton,
        TextEdit
    }
}
</script>

<style lang="scss" scoped>
@import './style.scss';

.notes-dialog {
    margin-right: 15px;
}
.notes {
    border: 1px solid #2D3E4F;
}
.event-head {
    display: flex;
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 10px;
    span:first-child {
        padding-left: 0;
    }
    span {
        padding: 0px 12px;
    }
}
.footer {
    display: flex;
    justify-content: space-between;
}
.inl-blk {
    display: inline-block;
}
.ask-text {
    position: relative;
    top: 30%;
}
</style>
<style scoped>
.text-edit {
    max-height: 400px;
    overflow-y: scroll;
}
.text-edit >>> b{
    color: #833e93;
}
</style>